import { BtnBox } from "../../style/common";
import Btn from "../common/Btn";
import GoBackBtn from "../common/GoBackBtn";

export default function AddBtns() {
  return (
    <BtnBox>
      <Btn type="submit" title="저장" color="blue" />
      <GoBackBtn />
    </BtnBox>
  );
}
